import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BaseChartDirective } from 'ng2-charts';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { PasswordRequirementsDialogComponent } from '../change-password/components/password-requirements-dialog/password-requirements-dialog.component';
import { FunctionalRolesDialogComponent } from '../modules/user-management/roles/functional-roles-dialog/functional-roles-dialog.component';
import { AuthLayoutComponent } from '../shared/_layouts/auth-layout/auth-layout.component';
import { FullComponent } from '../shared/_layouts/full/full.component';
import { ComingSoonComponent } from '../shared/coming-soon/coming-soon';

import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { AuditComponent } from './components/audit/audit.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ImagePreviewDialogComponent } from './components/image-preview-dialog/image-preview-dialog.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { TurnstileComponent } from './components/turnstile/turnstile.component';
import { AlphaNumericOnlyDirective } from './directives/alpah-numeric-input-controller/alpha-numeric.directive';
import { NumericOnlyDirective } from './directives/alpah-numeric-input-controller/numeric-only.directive';
import { AmountColorDirective } from './directives/amount-color/amount-color.directive';
import { CapitalizeEveryDirective } from './directives/capitalize-every/capitalize-every.directive';
import { CapitalizeFirstDirective } from './directives/capitalize-first/capitalize-first.directive';
import { FileInputResetDirective } from './directives/file-input-reset/file-input-reset.directive';
import { TrimSelectSearchDirective } from './directives/trim-select-search/trim-select-search.directive';
import { TwoStateSortDirective } from './directives/two-state-sort/two-state-sort.directive';
import { MaterialModule } from './material/material.module';
import { OverrideDisplayDescriptionPipe } from './pipes/override-display-description.pipe';
import { OverrideDisplayNamePipe } from './pipes/override-display-name.pipe';
import { StatusDisplayNamePipe } from './pipes/status-display-name.pipe';
import { PasswordService } from './services/password.service';

@NgModule({
  declarations: [
    AmountColorDirective,
    AlphaNumericOnlyDirective,
    NumericOnlyDirective,
    CapitalizeFirstDirective,
    CapitalizeEveryDirective,
    FileInputResetDirective,
    FullComponent,
    AuthLayoutComponent,
    SideNavComponent,
    ConfirmDialogComponent,
    FunctionalRolesDialogComponent,
    BreadcrumbComponent,
    PasswordRequirementsDialogComponent,
    AccessDeniedComponent,
    ComingSoonComponent,
    TurnstileComponent,
    PieChartComponent,
    AuditComponent,
    ImagePreviewDialogComponent,
    TrimSelectSearchDirective,
    TwoStateSortDirective,
    AddressFormComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MaterialModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxMatSelectSearchModule,
    ZXingScannerModule,
    BaseChartDirective,
    MatGridListModule,
    StatusDisplayNamePipe,
    OverrideDisplayNamePipe,
    OverrideDisplayDescriptionPipe
  ],
  exports: [
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatCardModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MaterialModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxMatSelectSearchModule,
    ZXingScannerModule,
    AmountColorDirective,
    AlphaNumericOnlyDirective,
    NumericOnlyDirective,
    CapitalizeFirstDirective,
    CapitalizeEveryDirective,
    FileInputResetDirective,
    BaseChartDirective,
    MatGridListModule,
    PieChartComponent,
    TurnstileComponent,
    AuditComponent,
    StatusDisplayNamePipe,
    OverrideDisplayNamePipe,
    OverrideDisplayDescriptionPipe,
    TrimSelectSearchDirective,
    TwoStateSortDirective,
    AddressFormComponent,
    PasswordRequirementsDialogComponent
  ],
  providers: [StatusDisplayNamePipe, OverrideDisplayNamePipe, OverrideDisplayDescriptionPipe, PasswordService]
})
export class SharedModule {}
